import { css } from "@emotion/react";
import { BgImageBtnMemberVip } from "assets/common/images/member-vip";
import { theme } from "styles/theme";

export const MemberVipPageStyle = {
  wrapper: css`
    background-color: ${theme.colors.gray[850]};
    border-radius: 10px;

    padding: 25px 196px 45px 196px;
  `,

  btnGroup: css`
    display: flex;
    flex-direction: column;
    gap: 20px;
  `,

  btnMemberVip: css`
    background: url(${BgImageBtnMemberVip}) center/cover no-repeat;
    color: #8b5211;
    font-size: 26px;
    text-decoration: none;
    cursor: pointer;
    height: 75px;

    position: relative;

    display: flex;
    align-items: center;
    img {
      width: 90px;
      height: 60px;
      margin: 0 30px 0 20px;
    }
    svg {
      position: absolute;
      right: 20px;
      fill: #8b5211;
      height: 26px;
      width: 16.25px;
    }
  `,
};
